import { createAsyncThunk } from "@reduxjs/toolkit";
import http from "../../../utils/http";
import { CreateBookingPayload } from "./types";
import { TableFilterParams } from "../util/types";
const BaseURL = process.env.REACT_APP_API_URL;

export const fetchOrganisationDashboardAnalytics = createAsyncThunk(
  "find_organisation_analytics",
  async (organisationId: string, { rejectWithValue }) => {
    try {
      const res = await http.get({
        url: `${BaseURL}/organisation-portal/get-dashboard-analytics/${organisationId}`,
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
export const findOrganisationBranchesAction = createAsyncThunk(
  "find_organisation_branches",
  async (organisationId: string, { rejectWithValue }) => {
    try {
      const res = await http.get({
        url: `${BaseURL}/organisation-portal/find-organisation-branches/${organisationId}`,
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const findAllProducts = createAsyncThunk(
  "find_all_products",
  async (body: { productTypes: Array<string> }, { rejectWithValue }) => {
    try {
      const res = await http.post({
        url: `${BaseURL}/products/find-all-products-by-product-types`,
        body:{
          productTypes: body.productTypes,
          isOrganisation: true
        },
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const createBookingAction = createAsyncThunk(
  "create_booking",
  async (payload: CreateBookingPayload, { rejectWithValue }) => {
    try {
      const res = await http.post({
        url: `${BaseURL}/organisation-portal/create-booking`,
        body: payload,
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const findFilteredOrganisationProducts = createAsyncThunk(
  "find_iltered_products",
  async (params: TableFilterParams, { rejectWithValue }) => {
    const { page, rows, productType, filters } = params;

    try {
      const res = await http.get({
        url: `${BaseURL}/products/find/filtered-products`,
        query: {
          page,
          rows,
          productType,
          searchString: filters?.global?.value,
        },
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const findOrganisationPercentageDiscount = createAsyncThunk(
  "find_organisation_percentage_discount",
  async (organisationId: string, { rejectWithValue }) => {
    try {
      const res = await http.get({
        url: `${BaseURL}/organisation-portal/find-organisation-percentage-discount/${organisationId}`,
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const findVoucherByCode = createAsyncThunk(
  "find-voucher-by-code",
  async (payload: { voucherCode: string }, { rejectWithValue }) => {
    try {
      const res = await http.get({
        url: `${BaseURL}/voucher/find-by-code/${payload.voucherCode}`,
      });

      return res;
    } catch (err: any) {
      if (!err.response) {
        throw err;
      }
    }
  }
);
